import { render, staticRenderFns } from "./StudyRight.vue?vue&type=template&id=2014e74f&"
import script from "./StudyRight.vue?vue&type=script&lang=js&"
export * from "./StudyRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports